/**
 * @module RoAppBackend/SettingsNames
 * @type {{BASE_URL: string, DEFAULT_MAP_LATITUDE: string, DEFAULT_MAP_LONGITUDE: string, DEFAULT_MAP_ZOOM: string, MAX_MAP_ZOOM: string, MAIN_LAYER_TILES_URL: string, MAP_COPYRIGHT: string, IMAGES_URL: string}}
 */
module.exports = {
    BASE_URL: "baseUrl",
    DEFAULT_MAP_LATITUDE: "defaultMapLatitude",
    DEFAULT_MAP_LONGITUDE: "defaultMapLongitude",
    DEFAULT_MAP_ZOOM: "defaultMapZoom",
    MAX_MAP_ZOOM: "maxMapZoom",
    MAIN_LAYER_TILES_URL: "mainLayerTilesUrl", //TODO: add base map tiles url
    MAP_COPYRIGHT: "mapCopyright",
    IMAGES_URL: 'imagesUrl'
}


//////////////////
// WEBPACK FOOTER
// .-backend/lib/models/app/settingsNames.js
// module id = 1AJr
// module chunks = 5